<template>
  <div class="bg_color">
    <top-header
      :type="6"
      :placeholder="'房源列表'"
      :hasBorder="true"
      :bgColor="'#fff'"
      fontSize="0.32rem"
    />
    <!-- <img src="@/assets/img/strictSelection/jieshao.jpg" alt="" /> -->
    <!-- <van-list
      :loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    > -->
    <div class="no_data" v-if="!list.length">
      <img src="@/assets/img/nodata.png" alt="" />
      <p>暂无数据</p>
    </div>
    <div
      class="inner bor_b"
      @click="
        gotoPage(
          item.corpName,
          item.itemName,
          item.buildingNo,
          item.unitNo,
          item.houseNo
        )
      "
      v-for="(item, index) in list"
      :key="index"
    >
      <h3 class="comp1">
        {{ item.itemName }} {{ item.buildingNo }}-{{ item.unitNo }}-{{
          item.houseNo
        }}
      </h3>
      <p class="row line_comp1">房屋面积：{{ item.buArea }}㎡</p>
      <!-- <div class="m_flex_box">
        <p class="row line_comp1">备案单价：{{ item.unitPrice }}元</p>
        <p class="row line_comp1" style="margin-left:0.3rem">
          优惠后单价：{{ item.discountUnit }}元
        </p>
      </div>
      <div class="m_flex_box">
        <p class="row line_comp1">
          备案总价：{{ item.totalPrice | formatwan }} 万元
        </p>
        <p class="row line_comp1" style="margin-left:0.3rem">
          优惠后总价：{{ item.discountTotal | formatwan }} 万元
        </p>
      </div> -->
    </div>
    <!-- </van-list> -->
  </div>
</template>

<script>
import topHeader from "@/components/header";
import "swiper/swiper-bundle.css";
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      textColor: "#fff",
      bgColor: "transparent",
    };
  },
  components: {
    topHeader,
  },
  filters: {
    formatwan(param) {
      if (param >= 10000) {
        return (param / 10000).toFixed(1);
      } else {
        return param;
      }
    },
  },
  created() {
    this.onLoad();
  },
  mounted() {},
  methods: {
    gotoPage(corpName, itemName, buildingNo, unitNo, houseNo) {
      this.$router.push({
        path: "/strictSelectionBuyHouse",
        query: {
          corpName: encodeURIComponent(encodeURIComponent(corpName)),
          itemName: encodeURIComponent(encodeURIComponent(itemName)),
          buildingNo: buildingNo,
          unitNo: unitNo,
          houseNo: houseNo,
        },
      });
    },
    onLoad() {
      this.$request_yx
        .post("oldnew/houseInfo/list", { itemId: this.$route.query.id })
        .then((res) => {
          if (res.success) {
            this.list = res.result;
          } else {
            this.$toast(res.message);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.bg_color {
  background-color: #fff;
  & > img {
    width: 100%;
  }
  h3 {
    font-weight: 800;
    font-size: 0.32rem;
    color: #1c1c1c;
    margin-bottom: 0.14rem;
  }
  .bor_b {
    border-bottom: 0.1rem solid #f4f4f4;
  }
  .inner {
    background-color: #fff;
    padding: 0.3rem 0.23rem;
    font-size: 0.24rem;
    p {
      margin-bottom: 0.1rem;
      line-height: 0.42rem;
      color: #666;
      .long_text {
        max-width: 50%;
      }
      i {
        margin: 0 0.1rem;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .tit {
      width: 1.8rem;
      padding-right: 0.3rem;
      box-sizing: border-box;
      text-align: right;
      color: #909090;
    }
    .text {
      width: 80%;
    }
  }
}
</style>
